/**
 * Проверяет, является ли переданный URL-адрес внешним по отношению к текущей странице.
 *
 * @param {string} url - URL-адрес, который нужно проверить.
 * @returns {boolean}
 * - `true`: если URL ведет на внешний ресурс (другой домен).
 * - `false`: если URL принадлежит текущему домену или является невалидным.
 *
 * @example
 * const externalUrl = "https://example.com";
 * const currentUrl = "/about-us";
 *
 * // Проверка внешнего URL
 * console.log(checkIfExternal(externalUrl)); // true
 *
 * // Проверка внутреннего URL
 * console.log(checkIfExternal(currentUrl)); // false
 *
 * // Проверка невалидного URL
 * console.log(checkIfExternal("not-a-valid-url")); // false
 *
 * @remarks
 * 1. Используется встроенный объект `URL` для проверки и анализа строки URL.
 * 2. Относительные URL всегда считаются внутренними.
 * 3. Если URL невалиден (вызывает ошибку при разборе), функция возвращает `false`.
 */
export default function (url: string): boolean {
  try {
    return new URL(url).origin !== window.location.origin;
  } catch (e) {
    return false;
  }
};
